import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Bucket = ({ title, data, testid }) => {
  const entries = Object.entries(data || {});
  return (
    <div className="bg-white rounded-lg border p-4" data-testid={testid}>
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">{title}</div>
      {entries.length === 0 && <div className="text-sm text-gray-400">No data yet</div>}
      <ul className="space-y-1">
        {entries.map(([k, v]) => (
          <li key={k} className="flex justify-between text-sm">
            <span className="text-gray-700 truncate mr-3">{k}</span>
            <span className="font-semibold text-gray-900">{v}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const CorpStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/corp/stats`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('adminToken')}` } })
      .then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return null;
  const order = stats.ctaClicksByPath?.order || 0;
  const partner = stats.ctaClicksByPath?.partner || 0;
  const total = order + partner || 1;

  return (
    <div className="space-y-3" data-testid="corp-stats">
      <div className="bg-white rounded-lg border p-4">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Conversion paths · CTA clicks</div>
        <div className="flex h-3 rounded overflow-hidden bg-gray-100">
          <div style={{ width: `${(order / total) * 100}%` }} className="bg-[#722F37]" />
          <div style={{ width: `${(partner / total) * 100}%` }} className="bg-[#C9A961]" />
        </div>
        <div className="flex justify-between mt-2 text-sm">
          <span data-testid="corp-stats-order"><span className="inline-block w-2 h-2 rounded-full bg-[#722F37] mr-1" />I need custom wine: <b>{order}</b></span>
          <span data-testid="corp-stats-partner"><span className="inline-block w-2 h-2 rounded-full bg-[#C9A961] mr-1" />Become a partner: <b>{partner}</b></span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <Bucket title="Clicks by CTA" data={stats.ctaClicksByCta} testid="corp-stats-cta" />
        <Bucket title="Order clicks by UTM source" data={stats.orderClicksBySource} testid="corp-stats-order-src" />
        <Bucket title="Partner clicks by UTM source" data={stats.partnerClicksBySource} testid="corp-stats-partner-src" />
        <Bucket title="Inquiries by intent" data={stats.inquiriesByIntent} testid="corp-stats-intent" />
      </div>
    </div>
  );
};

export default CorpStats;
